import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(postObject: Request): Promise<Optional<string>> {
	const url = `${SERVICEBASEURL.BACKEND}/NutrientCategory`;
	return axios.post(url, postObject).toOptionalMapped((x) => x.data);
}

export interface Request {
	parentId: string | null;
	nameTranslations: {
		[key: string]: string;
	};
	sortOrder: number;
}

export interface Response {
	data: string;
}
